import { AxiosError } from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../../../components/Notification';
import HttpStatus from '../../../../../../../enums/httpStatus';
import { communicationByActionAndOrderDeleteReq } from '../../../../../../../services/requests';
import * as TP from '../../../../../../../types/apiResponseTypes';
import * as s from '../styles';

type Props = {
  closeModal: () => void;
  reqGetAllCommunicationByActionAndOrder: () => void;
  itemSelected: TP.CommunicationByActionAndOrder;
};

const DeleteCommunicationByActionAndOrder = ({
  closeModal,
  reqGetAllCommunicationByActionAndOrder,
  itemSelected,
}: Props) => {
  const { t } = useTranslation();

  const [waitingDeleteCommunication, setWaitingDeleteCommunication] = useState(false);

  const reqDeleteCommunicationByActionAndOrder = async () => {
    setWaitingDeleteCommunication(true);

    const source = communicationByActionAndOrderDeleteReq.axios.CancelToken.source();

    try {
      const res = await communicationByActionAndOrderDeleteReq.store({
        motive_id: itemSelected.motive_id,
        action_id: itemSelected.action_id,
        order_origin_id: itemSelected.order_origin_id,
        communication_group_id: itemSelected.communication_group_id,
      });

      if (res.status === HttpStatus.OK) {
        setWaitingDeleteCommunication(false);
        frontendNotification({
          message: t('successfullyDeleted'),
          type: 'success',
        });

        closeModal();
        reqGetAllCommunicationByActionAndOrder();
      } else {
        throw res;
      }

      setWaitingDeleteCommunication(false);
    } catch (err) {
      if (!communicationByActionAndOrderDeleteReq.axios.isCancel(err)) {
        backendErrorNotification(err as AxiosError<any, any>);
      }
      setWaitingDeleteCommunication(false);
    }

    return () => {
      source.cancel('Component got unmounted');
    };
  };

  return (
    <Modal
      title={`${t('delete')}`}
      showModal
      closeModal={closeModal}
      action={() => reqDeleteCommunicationByActionAndOrder()}
      actionNameBtn={t('delete')}
      isLoading={waitingDeleteCommunication}
    >
      <s.ModalContent>
        <p>
          {`${t('deleteSure')}?`}
          <br />
          <br />
          <b>{t('motive')}:</b> {itemSelected.motive.description}
          <br />
          <br />
          <b>{t('action')}:</b> {itemSelected.action.label}
          <br />
          <br />
          <b>{t('origin')}:</b> {itemSelected.order_origin.label}
          <br />
          <br />
          <b>{t('communicationGroup')}:</b> {itemSelected.communication_group.description}
        </p>
      </s.ModalContent>
    </Modal>
  );
};

export default DeleteCommunicationByActionAndOrder;
